import { APICommunicator } from '~/api/APICommunicator';
import { parseContentDispositionFileName } from '~/utils/parseContentDispositionFileName';

export type FetchedFileBlob = {
    blobUrl: string;
    fileName?: string;
};

export const fetchFileAsBlob = async ({
    mimeType,
    route,
}: {
    route: string;
    mimeType?: string;
}): Promise<FetchedFileBlob> => {
    const response = await APICommunicator.apiFetch({
        context: { method: 'get' },
        route,
    });
    const responseMimeType = response.headers.get('content-type');
    const type = responseMimeType || mimeType || 'application/pdf';
    const fileName = parseContentDispositionFileName(response.headers.get('content-disposition'));

    // Create blob and URL
    const blob = await response.blob();
    return {
        blobUrl: URL.createObjectURL(type !== blob.type ? new Blob([blob], { type }) : blob),
        fileName: fileName ?? undefined,
    };
};
